/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/canvas/:workflow_id/step/:step_id/preview_path" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPathCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPathProps,
  EngagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPathResult,
} from "./types";

export const postEngagementCanvasStepPreviewPath = reactQueryMutationAdapter(
  engagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPathCacheKeys,
  (
    props: PostEngagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPathProps
  ): Promise<EngagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPathResult> => {
    // manipulate props here as needed param4

    return fetch(
      `/engagement/${props.app_group_id}/canvas/${props.workflow_id}/step/${props.step_id}/preview_path`,
      "POST",
      props
    );
  }
);
